// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + ".legacy." + "5a216cb8785a0807c055" + ".js";
};